import { projectService as ogpProjectService } from 'ogp/services';
import { projectService as hqProjectService } from 'hq/services';
import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';
import { QUERY_KEYS } from 'api/query-keys';
import { AddPlacementPayload } from '../../../../../../services/project-service.types';
import { SiteDetectionResult, useSiteDetection } from '../../../../../../hooks';

type PlacementMutationOptions = UseMutationOptions<unknown, unknown, AddPlacementPayload>;

export const useCreatePlacement = (options?: PlacementMutationOptions) => {
  const siteDetectionResult = useSiteDetection();
  const mutationFn = async (body: AddPlacementPayload) =>
    await getMutationFunction({ body, siteDetectionResult });
  const queryClient = useQueryClient();
  return useMutation(mutationFn, {
    ...options,
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries(QUERY_KEYS.projects());
      options && options?.onSuccess?.(data, variables, context);
    },
  });
};

type GetMutationFunctionParams = {
  body: AddPlacementPayload;
  siteDetectionResult: SiteDetectionResult;
};

const getMutationFunction = (props: GetMutationFunctionParams) => {
  const { body, siteDetectionResult } = props;

  if (siteDetectionResult.isHQ) {
    return hqProjectService.createPlacement(body);
  }
  if (siteDetectionResult.isOGP) {
    return ogpProjectService.createPlacement(body);
  }

  throw new Error(`useCreatePlacement: site "${siteDetectionResult.site}" is neither HQ nor OGP.`);
};
